// extracted by mini-css-extract-plugin
export default {"line":"InfractionDetailsContainer_line_byDW6"};